import api from './api';

const url = '/home';

export const getHomePageContent = async () => {
  return api({
    url,
    noAuth: true
  });
};